import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Input,
  CardHeader,
  Nav,
} from 'reactstrap';
import '../../../../../assets/intregation.css';
import { Separator } from '../../../../../components/common/CustomBootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import '../style/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { post_API_Send_Email } from '../../../../../constants/APIs';
import { NotificationManager } from '../../../../../components/common/react-notifications';


export default function VoucherCodeSnippet({ integration, propertyId }) {
  const [value, setValue] = useState('');
  const [iframevalue, setIframeValue] = useState('');
  const [copied, setCopied] = useState(false);
  const [iframecopied, setIframeCopied] = useState(false);
  const [activeTab, setActiveTab] = useState('standard');
  const [showEmailBox, setShowEmailBox] = useState(false);
  const [developerEmail, setDeveloperEmail] = useState('');
  const [directLink, setDirectLink] = useState('');
  const [directLinkCopied, setDirectLinkCopied] = useState('');
  const [embedScript, setEmbedScript] = useState('');
  const [embedIframevalue, setEmbedIframeValue] = useState('');
  const [embedIframecopied, setEmbedIframeCopied] = useState(false);
  const [embedScriptcopied, setEmbedScriptCopied] = useState(false);
  useEffect(() => {
    const gid = getGroupID();
    const iid = integration.id;
    const text = `<!-- This is start of the aiva voucher assistant code -->
    <script>
    var aiva_Voucher_domain = '${process.env.REACT_APP_VOUCHER_URL}/';
    var aiva_Voucher_botHTMLPath = aiva_Voucher_domain;
    var aiva_Voucher_head = document.getElementsByTagName('head')[0];
    var aiva_Voucher_script = document.createElement('script');
    aiva_Voucher_script.type = 'text/javascript';
    aiva_Voucher_script.src = aiva_Voucher_domain + 'voucherplugin.js';
    aiva_Voucher_head.appendChild(aiva_Voucher_script);
    var aiva_Voucher_gid = '${gid}';
    var aiva_Voucher_iid = '${iid}';
    var aiva_Voucher_pid = '';
    </script>
<!-- This is end of the aiva voucher assistant code -->`;
    const embedText = `<!-- This is start of the aiva voucher assistant code -->
<script>
var aiva_Voucher_domain = '${process.env.REACT_APP_VOUCHER_URL}/';
var aiva_Voucher_botHTMLPath = aiva_Voucher_domain;
var aiva_Voucher_head = document.getElementsByTagName('head')[0];
var aiva_Voucher_script = document.createElement('script');
aiva_Voucher_script.type = 'text/javascript';
aiva_Voucher_script.src = aiva_Voucher_domain + 'embedVoucherPlugin.js';
aiva_Voucher_head.appendChild(aiva_Voucher_script);
var aiva_Voucher_gid = '${gid}';
var aiva_Voucher_iid = '${iid}';
var aiva_Voucher_pid = '';
</script>
<!-- This is end of the aiva voucher assistant code -->`;
    setEmbedScript(embedText);
    setValue(text);
    const iframetext = `<iframe frameborder="0" style="bottom: 0; right: 0; margin: 0; z-index: 2000001;height:630px;width:390px;" id="voucherbotiframe" src="${process.env.REACT_APP_VOUCHER_URL}/voucherengine?location=&amp;title=&amp;referrer=&amp;iid=${iid}&amp;gid=${gid}&amp;mobile=false&amp;open=1&custom=1"></iframe>`;
    setIframeValue(iframetext);

    const embedIframeText = `<iframe frameborder="0" style="bottom: 0; right: 0; margin: 0; z-index: 2000001;height:630px;width:390px;" id="voucherFrame" src="${process.env.REACT_APP_VOUCHER_URL}/embedVoucher?location=&amp;title=&amp;referrer=&amp;iid=${iid}&amp;gid=${gid}&amp;mobile=false&amp;open=1&embed=1&custom=1"></iframe>`;
    setEmbedIframeValue(embedIframeText);

    const link = `${process.env.REACT_APP_VOUCHER_URL}/voucherengine?location=&title=&referrer=&iid=${integration.id}&gid=${getGroupID()}&mobile=false&open=1&custom=1`;
    setDirectLink(link);
  }, []);

  const RedirectToDemo = () => {
    var url = `${process.env.REACT_APP_VOUCHER_BOT_DEMO}?gid=${getGroupID()}&iid=${integration.id}`;
    window.open(url, '_blank');
  };
  const RedirectToIframeDemo = () => {
    var url = `${process.env.REACT_APP_VOUCHER_URL}/voucherengine?gid=${getGroupID()}&iid=${integration.id}`;
    window.open(url, '_blank');
  };
  const RedirectToDirectLink = () => {
    var url = `${process.env.REACT_APP_VOUCHER_URL}/voucherengine?location=&title=&referrer=&iid=${integration.id}&gid=${getGroupID()}&mobile=false&open=1&custom=1`;
    window.open(url, '_blank');
  };


  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };

  const SendEmail = () => {

    let data = {
      'groupId': getGroupID(), intregationId: integration.id,
      'Email': developerEmail, 'PropertyId': propertyId
    };
    AxiosAPI({
      method: 'post',
      url: `${post_API_Send_Email}`,
      data,
    })
      .then((res) => {
        NotificationManager.success(
          '',
          'Email sended successfully',
          2000,
          null,
          null,
          'success'
        );
      })
  };
  return (
    <Fragment>
      <CardHeader className="pl-0 pr-0">
        <Nav tabs className="card-header-tabs ml-0 mr-0 row ">
          <NavItem className="w-50 text-center col-md-4">
            <NavLink
              className={classnames({
                active: activeTab === 'standard',
                'nav-link': true,
              })}
              onClick={() => {
                toggleAppMenu('standard');
              }}
              to="#"
            >
              Standard
            </NavLink>
          </NavItem>
          <NavItem className="w-50 text-center col-md-4">
            <NavLink
              className={classnames({
                active: activeTab === 'embed',
                'nav-link': true,
              })}
              onClick={() => {
                toggleAppMenu('embed');
              }}
              to="#"
            >
              Embed
            </NavLink>
          </NavItem>
          <NavItem className="w-50 text-center col-md-4">

            <NavLink
              className={classnames({
                active: activeTab === 'directLink',
                'nav-link': true,
              })}
              onClick={() => {
                toggleAppMenu('directLink');
              }}
              to="#"
            >
              Direct Link
            </NavLink>
          </NavItem>  
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab} className="">
        <TabPane tabId="standard" className="chat-app-tab-pane ">
          <Card className="mb-4">
            <CardBody>
              <h6 className="text-center">Publish your Vouchers</h6>
              <Separator className="mb-3" />
              <div className="code-snippet">
                <span>
                  {' '}
                  &lt;&#33;&#45;&#45; This is start of the <strong>aiva</strong> voucher
                  assistant code &#45;&#45;&gt;
                </span>
                <span>&lt;script&gt;</span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_domain ='{process.env.REACT_APP_VOUCHER_URL}';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_botHTMLPath =
                  aiva_Voucher_domain;
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_head =
                  document.getElementsByTagName('head')[0];
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_script =
                  document.createElement('script');
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;aiva_Voucher_script.type =
                  'text/javascript';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;aiva_Voucher_script.src =
                  aiva_Voucher_domain + 'voucherplugin.js';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;aiva_Voucher_head.appendChild(aiva_Voucher_script);
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_gid = '{getGroupID()}
                  ';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_iid = '
                  {integration.id}';
                </span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_pid = '';</span>
                <span>&lt;/script&gt;</span>
                <span>
                  {' '}
                  &lt;&#33;&#45;&#45; This is end of the <strong>aiva</strong> voucher
                  assistant code &#45;&#45;&gt;{' '}
                </span>
              </div>
              <div className="text-center">
                <div>
                  <b>
                    Copy and paste this code before the closing &lt;/body&gt;
                    tag on every page of your website.
                  </b>
               </div>
                <Button
                    color="success"
                    className='mr-1'
                    size="xs"
                    style={{ marginTop: '10px' }}
                    onClick={()=>setShowEmailBox(!showEmailBox)}
                  >
                    Email to developer
                  </Button>
                <CopyToClipboard text={value} onCopy={() => setCopied(true)}>
                  <Button
                    color="success"
                    size="xs"
                    style={{ marginTop: '10px', marginLeft: '20px' }}
                  >
                    Copy the code snippet
                  </Button>
                </CopyToClipboard>
                <Button
                  color="success"
                  size="xs"
                  style={{ marginTop: '10px', marginLeft: '20px' }}
                  onClick={RedirectToDemo}
                >
                  Preview
                </Button>

                {copied ? <div>Copied.</div> : null}
              </div>
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="embed" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              <h6 className="text-center">Embed your Assistant</h6>
              <Separator className="mb-3" />
              <div className="code-snippet">
                <span>
                  &lt;iframe frameborder="0" style="bottom: 0; right: 0; margin:
                  0; z-index: 2000001;height:630px;width:390px;"
                  id="voucherbotiframe" src="https://vouchers.getaiva.com/voucherengine?location=&amp;title=&amp;referrer=&amp;iid=
                  {integration.id}&amp;gid={getGroupID()}
                  &amp;mobile=false&amp;open=1&custom=1"&gt;&lt;/iframe&gt;
                </span>
              </div>
              <div className="text-center">
                <div>
                  <b>
                    Copy and paste this code at desired location on the page of
                    your website.
                  </b>
                </div>

                <CopyToClipboard
                  text={iframevalue}
                  onCopy={() => setIframeCopied(true)}
                >
                  <Button
                    color="success"
                    size="xs"
                    style={{ marginTop: '10px' }}
                  >
                    Copy the code snippet
                  </Button>
                </CopyToClipboard>
                <Button
                  color="success"
                  size="xs"
                  style={{ marginTop: '10px', marginLeft: '20px' }}
                  onClick={RedirectToIframeDemo}
                >
                  Preview
                </Button>
                {iframecopied ? <div>Copied.</div> : null}
              </div>
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="directLink" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              <h6 className="text-center">Direct Link</h6>
              <Separator className="mb-3" />
              <div className="code-snippet">
                <span>
                  https://vouchers.getaiva.com/voucherengine?location=&amp;title=&amp;referrer=&amp;iid=
                  {integration.id}&amp;gid={getGroupID()}
                  &amp;mobile=false&amp;open=1&custom=1
                </span>
              </div>
              <div className="text-center">
                <div>
                  <b>
                    Copy and paste this code at desired location on the page of
                    your website.
                  </b>
                </div>

                <CopyToClipboard
                  text={directLink}
                  onCopy={() => setDirectLinkCopied(true)}
                >
                  <Button
                    color="success"
                    size="xs"
                    style={{ marginTop: '10px' }}
                  >
                    Copy the URL
                  </Button>
                </CopyToClipboard>
                <Button
                  color="success"
                  size="xs"
                  style={{ marginTop: '10px', marginLeft: '20px' }}
                  onClick={RedirectToDirectLink}
                >
                  Preview
                </Button>
                {directLinkCopied ? <div>Copied.</div> : null}
              </div>
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="embedVoucher" className="chat-app-tab-pane">
        <Card className="mb-4">
            <CardBody>
              <h6 className="text-center">Publish your Vouchers</h6>
              <Separator className="mb-3" />
              <div className="code-snippet">
                <span>
                  {' '}
                  &lt;&#33;&#45;&#45; This is start of the <strong>aiva</strong> voucher
                  assistant code &#45;&#45;&gt;
                </span>
                <span>&lt;script&gt;</span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_domain ='{process.env.REACT_APP_VOUCHER_URL}/';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_botHTMLPath =
                  aiva_Voucher_domain;
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_head =
                  document.getElementsByTagName('head')[0];
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_script =
                  document.createElement('script');
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;aiva_Voucher_script.type =
                  'text/javascript';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;aiva_Voucher_script.src =
                  aiva_Voucher_domain + 'embedVoucherPlugin.js';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;aiva_Voucher_head.appendChild(aiva_Voucher_script);
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_gid = '{getGroupID()}
                  ';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_iid = '
                  {integration.id}';
                </span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;var aiva_Voucher_pid = '';</span>
                <span>&lt;/script&gt;</span>
                <span>
                  {' '}
                  &lt;&#33;&#45;&#45; This is end of the <strong>aiva</strong> voucher
                  assistant code &#45;&#45;&gt;{' '}
                </span>
              </div>
              <div className="text-center">
                <div>
                  <b>
                    Copy and paste this code before the closing &lt;/body&gt;
                    tag on every page of your website.
                  </b>
                </div>              
                <CopyToClipboard text={embedScript} onCopy={() => setEmbedScriptCopied(true)}>
                  <Button
                    color="success"
                    size="xs"
                    style={{ marginTop: '10px', marginLeft: '20px' }}
                  >
                    Copy the code snippet
                  </Button>
                </CopyToClipboard>               
                {embedScriptcopied ? <div>Copied.</div> : null}
              </div>
            </CardBody>
            <CardBody>
              <h6 className="text-center">Embed your Assistant</h6>
              <Separator className="mb-3" />
              <div className="code-snippet">
                <span>
                  &lt;iframe frameborder="0" style="bottom: 0; right: 0; margin:
                  0; z-index: 2000001;height:630px;width:390px;"
                  id="voucherFrame" src="{process.env.REACT_APP_VOUCHER_URL}/embedVoucher?location=&amp;title=&amp;referrer=&amp;iid=
                  {integration.id}&amp;gid={getGroupID()}
                  &amp;mobile=false&amp;open=1&embed=1&custom=1"&gt;&lt;/iframe&gt;
                </span>
              </div>
              <div className="text-center">
                <div>
                  <b>
                    Copy and paste this code at desired location on the page of
                    your website.
                  </b>
                </div>

                <CopyToClipboard
                  text={embedIframevalue}
                  onCopy={() => setEmbedIframeCopied(true)}
                >
                  <Button
                    color="success"
                    size="xs"
                    style={{ marginTop: '10px' }}
                  >
                    Copy the code snippet
                  </Button>
                </CopyToClipboard>
                {/* <Button
                  color="success"
                  size="xs"
                  style={{ marginTop: '10px', marginLeft: '20px' }}
                  onClick={RedirectToIframeDemo}
                >
                  Preview
                </Button> */}
                {embedIframecopied ? <div>Copied.</div> : null}
              </div>
            </CardBody>
          </Card>
        </TabPane>
      </TabContent>
      <Modal className='intregation-modal-content' style={{borderRadius:'10px'}} isOpen={showEmailBox} toggle={()=>setShowEmailBox(!showEmailBox)}>
        <ModalHeader toggle={()=>setShowEmailBox(!showEmailBox)}>
          Your developer`s e-mail address:
        </ModalHeader>
        <ModalBody>
           <p>
              Your developer teammate will receive an e-mail containing the code
              and necessary instructions to implement it.
           </p >
           <p >
            <Input
              className='mt-2'
              style={{borderRadius:'10px'}}
              type="text"
              name="email"    
              value={developerEmail}          
              placeholder="E-mail"
              onChange={(e)=>setDeveloperEmail(e.target.value)}
            />
           </p>
        </ModalBody>
        <ModalFooter>
        <Button
            color="success"
            size="xs"
            style={{ marginTop: '10px', marginLeft: '20px' }}
            onClick={()=>{SendEmail();setDeveloperEmail(''); setShowEmailBox(!showEmailBox);}}
          >
           <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon><span className='ml-2' >Send</span> 
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
